import * as React from "react";
import Select from "react-select";
import Modal from "../core/Modal";
import Button from "../core/Button";
import { useCallback, useMemo, useState } from "react";
import { addRoleToUser } from "../../libs/user";
import { RoleBadge } from "../core/RoleBadges";

function AddSalespersonModal({ users, usersPromise }) {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addingUser, setAddingUser] = useState(false);

  const [userIdToAdd, setUserIdToAdd] = useState(null);
  const userToAdd = userIdToAdd ? users.find(u => u.id === userIdToAdd) : null;

  const nonSalespeople = useMemo(
    () => (users ? users.filter(u => !u.roles.includes("sales")) : []),
    [users]
  );

  const addUser = useCallback(
    async function addUser() {
      setAddingUser(true);
      await addRoleToUser(userToAdd, "sales");
      await usersPromise.reload();
      setAddingUser(false);
      setAddModalOpen(false);
    },
    [userToAdd, usersPromise]
  );

  return (
    <>
      <Button onClick={() => setAddModalOpen(true)}>
        <i className="fa fa-plus" /> Add Salesperson
      </Button>
      <Modal
        title={"Add Salesperson"}
        open={addModalOpen}
        close={() => setAddModalOpen(false)}
        submitText={"Add"}
        onSubmit={addUser}
        isSubmitting={addingUser}
      >
        <Select
          options={nonSalespeople.map(u => ({ label: u.name, value: u.id }))}
          isLoading={usersPromise.loading}
          value={
            userToAdd ? { label: userToAdd.name, value: userToAdd.id } : null
          }
          onChange={(opt: ISelectOption) => setUserIdToAdd(opt.value)}
          clearable={false}
        />
        <small>
          This will apply the <RoleBadge>Sales</RoleBadge> role to the chosen
          user.
        </small>
      </Modal>
    </>
  );
}

export default AddSalespersonModal;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/AddSalespersonModal.tsx